document.addEventListener("DOMContentLoaded", () => {
  const sectionValues = document.querySelectorAll('.hn-values-section')
	if (sectionValues.length > 0) {
		sectionValues.forEach(section => {
			const sectionValue = new Swiper(section.querySelector('.swiper'), {
				loop: false,
				spaceBetween: 8,
				slidesPerView: 'auto',
				mousewheel: {
					releaseOnEdges: true,
				},
				navigation: {
					nextEl: section?.querySelector('.swiper-button-next'),
					prevEl: section?.querySelector('.swiper-button-prev'),
				},
				pagination: {
				  el: section?.querySelector('.swiper-pagination'),
				},
			})
		})
	}
	const boxes = document.querySelectorAll('.block-collection-link');
	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
			} else {
				entry.target.classList.remove('active');
			}
			});
		},
		{
			threshold: 1,
		}
	);
	boxes.forEach(box => observer.observe(box));
})
